import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './focus-trap.scss.js';
import { queryShadowRoot } from './search-tree.js';
/**
 * @element cipublic-focus-trap
 */
const shadowDomSelectors = `
    a[href],
    area[href],
    input:not([disabled]),
    select:not([disabled]),
    textarea:not([disabled]),
    button:not([disabled]),
    [tabindex="0"]
    `;
export class FocusTrap extends CipublicElement {
    constructor() {
        super(...arguments);
        this._isTrapped = false;
        this.arrowKeysEnabled = false;
        this.trapDisabled = false;
    }
    set isTrapped(trapped) {
        if (trapped) {
            this._isTrapped = true;
            this.addEventListener('keydown', this._handleKeydown);
            this._findAllChildNodes();
        }
        else {
            this._isTrapped = false;
            this.removeEventListener('keydown', this._handleKeydown);
            this.focusableElements = [];
        }
    }
    getFocusableElements() {
        return queryShadowRoot(this, this.isHidden, this.isFocusable);
    }
    _returnFocusableElement(elements, position) {
        var _a, _b;
        const isLast = position === 'last';
        const element = elements[isLast ? elements.length - 1 : 0];
        return element.tagName.includes('CIPUBLIC')
            ? (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll(shadowDomSelectors)[isLast ? ((_b = element.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll(shadowDomSelectors).length) - 1 : 0]
            : element;
    }
    isHidden($elem) {
        return ($elem.hasAttribute('hidden') ||
            $elem.hasAttribute('focus-trap-hidden') ||
            ($elem.hasAttribute('aria-hidden') && $elem.getAttribute('aria-hidden') !== 'false') ||
            $elem.style.display === `none` ||
            $elem.style.opacity === `0` ||
            $elem.style.visibility === `hidden` ||
            $elem.style.visibility === `collapse`);
    }
    isDisabled($elem) {
        return $elem.hasAttribute('disabled') || ($elem.hasAttribute('aria-disabled') && $elem.getAttribute('aria-disabled') !== 'false');
    }
    isFocusable($elem) {
        // if ($elem.getAttribute('tabindex') === '-1' || this.isHidden($elem) || this.isDisabled($elem)) {
        //   return false;
        // }
        if ($elem.getAttribute('tabindex') === '-1')
            return false;
        return ($elem.hasAttribute('tabindex') ||
            (($elem instanceof HTMLAnchorElement || $elem instanceof HTMLAreaElement) && $elem.hasAttribute('href')) ||
            $elem instanceof HTMLButtonElement ||
            $elem instanceof HTMLInputElement ||
            $elem instanceof HTMLTextAreaElement ||
            $elem instanceof HTMLSelectElement ||
            $elem instanceof HTMLIFrameElement);
    }
    _findAllChildNodes() {
        this.focusableElements = this.getFocusableElements();
        if (this.focusableElements.length) {
            this.firstFocusElement = this._returnFocusableElement(this.focusableElements, 'first');
            this.lastFocusElement = this._returnFocusableElement(this.focusableElements, 'last');
        }
    }
    _handleKeydown(event) {
        var _a, _b;
        const activeElement = event.composedPath()[0];
        const isTabPressed = event.key === 'Tab';
        const upArrowPressed = event.key === 'ArrowUp' && this.arrowKeysEnabled;
        const downArrowPressed = event.key === 'ArrowDown' && this.arrowKeysEnabled;
        if (!isTabPressed && !downArrowPressed && !upArrowPressed)
            return;
        if (this.focusableElements && this.focusableElements.length) {
            const focusableElementsLen = this.focusableElements.length;
            const currentPosition = this.focusableElements.indexOf(activeElement);
            const previousPosition = this.focusableElements[(currentPosition + focusableElementsLen - 1) % focusableElementsLen];
            const nextPosition = this.focusableElements[(currentPosition + 1) % focusableElementsLen];
            if (event.shiftKey || upArrowPressed) {
                if (activeElement === this.firstFocusElement) {
                    if (!this.trapDisabled) {
                        (_a = this.lastFocusElement) === null || _a === void 0 ? void 0 : _a.focus();
                        event.preventDefault();
                    }
                    else if (upArrowPressed) {
                        previousPosition.focus();
                        event.preventDefault();
                    }
                    else {
                        return;
                    }
                }
                else if (upArrowPressed) {
                    previousPosition.focus();
                    event.preventDefault();
                }
                else {
                    return;
                }
            }
            else {
                if (activeElement === this.lastFocusElement) {
                    if (!this.trapDisabled) {
                        (_b = this.firstFocusElement) === null || _b === void 0 ? void 0 : _b.focus();
                        event.preventDefault();
                    }
                    else if (downArrowPressed) {
                        nextPosition.focus();
                        event.preventDefault();
                    }
                    else {
                        return;
                    }
                }
                else if (downArrowPressed) {
                    nextPosition.focus();
                    event.preventDefault();
                }
                else {
                    return;
                }
            }
        }
    }
    render() {
        return html `<slot></slot>`;
    }
}
FocusTrap.styles = styles;
__decorate([
    property({ type: Boolean, attribute: 'trapped' })
], FocusTrap.prototype, "isTrapped", null);
__decorate([
    property({ type: Array, attribute: false })
], FocusTrap.prototype, "focusableElements", void 0);
__decorate([
    property({ attribute: false })
], FocusTrap.prototype, "firstFocusElement", void 0);
__decorate([
    property({ attribute: false })
], FocusTrap.prototype, "lastFocusElement", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], FocusTrap.prototype, "arrowKeysEnabled", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], FocusTrap.prototype, "trapDisabled", void 0);
//# sourceMappingURL=focus-trap.js.map